/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

/**
      * EnforcementState describes how far the claim has progressed. Mirrors
IAS's own DomainClaimEnforcementState so the two systems use the same
names for the same concept.

 - ENFORCEMENT_STATE_UNSPECIFIED: ENFORCEMENT_STATE_UNSPECIFIED is the default unset value.
 - ENFORCEMENT_STATE_GRACE_PERIOD: ENFORCEMENT_STATE_GRACE_PERIOD: the claim's 30-day grace period is in
progress; not every user on the domain has been transitioned to
managed_by=ORGANIZATION yet.
 - ENFORCEMENT_STATE_ENFORCED: ENFORCEMENT_STATE_ENFORCED: the claim workflow has completed; every
user on the domain has been transitioned.
      * @Example No example provided
      */
export enum CoinbaseEngUsersAccountManagementApiApiOrganizationDomainClaimEnforcementState {
  ENFORCEMENT_STATE_UNSPECIFIED = 'ENFORCEMENT_STATE_UNSPECIFIED',
  ENFORCEMENT_STATE_GRACE_PERIOD = 'ENFORCEMENT_STATE_GRACE_PERIOD',
  ENFORCEMENT_STATE_ENFORCED = 'ENFORCEMENT_STATE_ENFORCED',
}
export const getCoinbaseEngUsersAccountManagementApiApiOrganizationDomainClaimEnforcementStateErrors =
  (value: unknown): { fieldName: string; error: string }[] => {
    if (process.env.NODE_ENV === 'production') return [];
    if (
      !Object.values(
        CoinbaseEngUsersAccountManagementApiApiOrganizationDomainClaimEnforcementState,
      ).includes(value as any)
    ) {
      return [
        {
          fieldName: '',
          error: ` ${value} is not a valid CoinbaseEngUsersAccountManagementApiApiOrganizationDomainClaimEnforcementState.`,
        },
      ];
    } else {
      return [];
    }
  };

const validateCoinbaseEngUsersAccountManagementApiApiOrganizationDomainClaimEnforcementState = (
  value: unknown,
) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiOrganizationDomainClaimEnforcementStateErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CoinbaseEngUsersAccountManagementApiApiOrganizationDomainClaimEnforcementState data does not match contract.`,
      errors,
    );
  }
};
